let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6mSYZ")).then(() => parcelRequire('etjNp'));